import {ACTION_CODE} from './_actionCode';
import {ProjectsService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'DELETE_PROJECT';

export async function deleteProject(token = '', projectId: number | string) {
    try {
        LoggerService.logInfo('Action - deleteProject - Start');

        const result = await ProjectsService.deleteProject(token, projectId);

        LoggerService.logInfo('Action - deleteProject - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteProject - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression du projet',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
